import { PipeTransform, Pipe, Injectable } from '@angular/core';
import { MapedRegistriesByNurseInfoController } from '../../models/registry/registry.model';



@Pipe({
  name: 'MappedRegistriesByNurseInfo'
})

@Injectable()
export class MappedRegistriesByNurseInfoPipe implements PipeTransform {

  transform(value: MapedRegistriesByNurseInfoController[], filter: string): MapedRegistriesByNurseInfoController[] {
    filter = filter ? filter.toLocaleLowerCase() : null;
    return filter ? value.filter((app: MapedRegistriesByNurseInfoController) =>
      app.DisplayName != null && app.DisplayName.toLocaleLowerCase().indexOf(filter) != -1
     
    ) : value;
  }

}
